<template>
  <div
    class="copa-tv-fechada-container"
    :class="[`position-${posicaoEnquete}`, { 'fullscreen-mode': isFullScreen, 'standalone': !combined }]"
    :key="item.id"
  >
    <div class="poll-content-wrapper">
      <!-- Title Bar -->
      <div v-if="!hideTitle" class="title-container">
        <div class="title-bg-wrapper">
          <div class="bg-left">
            <svg class="title-bg-svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 573.08 54.28" preserveAspectRatio="xMinYMid slice">
              <defs>
                <linearGradient id="title-gradient-left" x1="0" y1="27.14" x2="573.08" y2="27.14" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stop-color="#02032f"/>
                  <stop offset="1" stop-color="#075cd3"/>
                </linearGradient>
              </defs>
              <path fill="url(#title-gradient-left)" d="M548.39,15.35h-5.89c1.45,3.81,2.18,7.76,2.18,11.79s-.73,7.98-2.18,11.79h5.89c1.31-3.83,1.97-7.77,1.97-11.79s-.66-7.96-1.97-11.79ZM29.28,22.36c-2.25-2.26-4.57-4.42-6.95-6.5H4.87c5.96,4.19,11.56,8.91,16.78,14.13l.66.66h14.62c-2.42-2.85-4.97-5.62-7.65-8.29ZM27.9,54.14h496.15v-.08l.36-.04c-.12.09-.24.18-.35.26h7.72c3.52-3.21,6.38-6.78,8.53-10.66.86-1.53,1.59-3.1,2.19-4.69h-5.94c1.62-3.79,2.44-7.74,2.44-11.79s-.82-8-2.44-11.79h5.94c-.6-1.59-1.33-3.15-2.19-4.69-2.15-3.88-5.01-7.45-8.53-10.66H0c7.94,4.52,15.41,9.82,22.33,15.86h15.71c4.58,4.68,8.82,9.61,12.71,14.79h13.25c4.62,6.85,8.7,14.05,12.23,21.58h-12.01c-3.87-7.59-8.37-14.79-13.47-21.58h-13.82c5.71,6.71,10.73,13.92,15.03,21.58h-12.55c-4.87-7.76-10.59-14.97-17.1-21.58H6.41c2.62,2.2,5.16,4.53,7.61,6.97,4.55,4.56,8.69,9.43,12.39,14.61l1.49,1.91ZM560.07,15.35h-5.83c1.2,3.84,1.8,7.78,1.8,11.79s-.6,7.95-1.8,11.79h5.83c1.09-3.85,1.65-7.79,1.65-11.79s-.56-7.94-1.65-11.79ZM571.65,15.35h-5.78c1.02,3.86,1.53,7.8,1.53,11.79s-.51,7.93-1.53,11.79h5.78c.95-3.86,1.43-7.8,1.43-11.79s-.48-7.92-1.43-11.79ZM548.39,38.93c-.74,2.17-1.69,4.3-2.85,6.38-1.76,3.19-3.96,6.19-6.58,8.97h6.84c1.9-2.31,3.57-4.74,4.97-7.28,1.46-2.63,2.62-5.32,3.47-8.07h-5.85ZM560.07,38.93c-.95,3.33-2.31,6.59-4.07,9.76-1.06,1.92-2.26,3.79-3.6,5.59h6.45c.85-1.27,1.65-2.58,2.39-3.9,2.05-3.72,3.6-7.54,4.63-11.45h-5.8ZM550.77,7.28c-1.4-2.54-3.07-4.97-4.97-7.28h-6.84c2.62,2.79,4.82,5.78,6.58,8.97,1.16,2.08,2.11,4.21,2.85,6.38h5.85c-.85-2.75-2.01-5.44-3.47-8.07ZM561.24,3.91c-.74-1.33-1.54-2.63-2.39-3.91h-6.45c1.34,1.8,2.54,3.67,3.6,5.59,1.76,3.17,3.12,6.43,4.07,9.76h5.8c-1.03-3.91-2.58-7.73-4.63-11.44Z"/>
            </svg>
          </div>
          <div class="bg-middle"></div>
          <div class="bg-right">
            <svg class="title-bg-svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 573.08 54.28" preserveAspectRatio="xMaxYMid slice">
              <defs>
                <linearGradient id="title-gradient-right" x1="0" y1="27.14" x2="573.08" y2="27.14" gradientUnits="userSpaceOnUse">
                  <stop offset="0" stop-color="#02032f"/>
                  <stop offset="1" stop-color="#075cd3"/>
                </linearGradient>
              </defs>
              <path fill="url(#title-gradient-right)" d="M548.39,15.35h-5.89c1.45,3.81,2.18,7.76,2.18,11.79s-.73,7.98-2.18,11.79h5.89c1.31-3.83,1.97-7.77,1.97-11.79s-.66-7.96-1.97-11.79ZM29.28,22.36c-2.25-2.26-4.57-4.42-6.95-6.5H4.87c5.96,4.19,11.56,8.91,16.78,14.13l.66.66h14.62c-2.42-2.85-4.97-5.62-7.65-8.29ZM27.9,54.14h496.15v-.08l.36-.04c-.12.09-.24.18-.35.26h7.72c3.52-3.21,6.38-6.78,8.53-10.66.86-1.53,1.59-3.1,2.19-4.69h-5.94c1.62-3.79,2.44-7.74,2.44-11.79s-.82-8-2.44-11.79h5.94c-.6-1.59-1.33-3.15-2.19-4.69-2.15-3.88-5.01-7.45-8.53-10.66H0c7.94,4.52,15.41,9.82,22.33,15.86h15.71c4.58,4.68,8.82,9.61,12.71,14.79h13.25c4.62,6.85,8.7,14.05,12.23,21.58h-12.01c-3.87-7.59-8.37-14.79-13.47-21.58h-13.82c5.71,6.71,10.73,13.92,15.03,21.58h-12.55c-4.87-7.76-10.59-14.97-17.1-21.58H6.41c2.62,2.2,5.16,4.53,7.61,6.97,4.55,4.56,8.69,9.43,12.39,14.61l1.49,1.91ZM560.07,15.35h-5.83c1.2,3.84,1.8,7.78,1.8,11.79s-.6,7.95-1.8,11.79h5.83c1.09-3.85,1.65-7.79,1.65-11.79s-.56-7.94-1.65-11.79ZM571.65,15.35h-5.78c1.02,3.86,1.53,7.8,1.53,11.79s-.51,7.93-1.53,11.79h5.78c.95-3.86,1.43-7.8,1.43-11.79s-.48-7.92-1.43-11.79ZM548.39,38.93c-.74,2.17-1.69,4.3-2.85,6.38-1.76,3.19-3.96,6.19-6.58,8.97h6.84c1.9-2.31,3.57-4.74,4.97-7.28,1.46-2.63,2.62-5.32,3.47-8.07h-5.85ZM560.07,38.93c-.95,3.33-2.31,6.59-4.07,9.76-1.06,1.92-2.26,3.79-3.6,5.59h6.45c.85-1.27,1.65-2.58,2.39-3.9,2.05-3.72,3.6-7.54,4.63-11.45h-5.8ZM550.77,7.28c-1.4-2.54-3.07-4.97-4.97-7.28h-6.84c2.62,2.79,4.82,5.78,6.58,8.97,1.16,2.08,2.11,4.21,2.85,6.38h5.85c-.85-2.75-2.01-5.44-3.47-8.07ZM561.24,3.91c-.74-1.33-1.54-2.63-2.39-3.91h-6.45c1.34,1.8,2.54,3.67,3.6,5.59,1.76,3.17,3.12,6.43,4.07,9.76h5.8c-1.03-3.91-2.58-7.73-4.63-11.44Z"/>
            </svg>
          </div>
        </div>
        <span class="title-text">{{ item.dsc_titulo_enquete }}</span>
      </div>

      <!-- Main Content Area -->
      <div class="options-container" :class="{ 'options-wide': hasEnqueteImage && hasLongOptionLabel, 'with-qrcode': combined }">
        <!-- Enquete Image (Flag) -->
        <div v-if="hasEnqueteImage" class="enquete-image-section">
          <img
            :src="item.url_imagem_enquete"
            :alt="item.dsc_titulo_enquete"
            class="enquete-image"
            @error="handleEnqueteImageError"
          />
        </div>

        <div class="options-grid" :class="{ 'has-images': hasOptionsWithImages }">
          <div
            v-for="opcao in limitedOpcoes"
            :key="opcao.id"
            class="option-item"
          >
            <div v-if="!hasEnqueteImage && opcao.url_imagem && !brokenImages[opcao.id]" class="option-image">
              <img
                :src="opcao.url_imagem"
                :alt="opcao.dsc_titulo"
                @error="handleImageError(opcao.id)"
              />
            </div>

            <div class="option-content">
              <span v-if="!hideOptionTitle" class="option-label">{{ formatOptionLabel(opcao.dsc_titulo) }}</span>
              <div v-if="item.flg_exibir_resultado" class="percentage-row">
                <span class="percentage-value">
                  {{ animatedPercentages[opcao.id] || 0 }}%
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardTarjaEnqueteCopaTVFechada',
  props: {
    item: Object,
    posicaoEnquete: String,
    isFullScreen: Boolean,
    hideTitle: Boolean,
    hideOptionTitle: Boolean,
    // True when embedded in the combined (QR + poll) wrapper. Enables the QR-overlap
    // spacing; standalone (enquete-only) mode keeps a normal left inset.
    combined: { type: Boolean, default: false },
  },
  data() {
    return {
      animatedPercentages: {},
      animationDuration: 1200,
      brokenImages: {},
      brokenEnqueteImage: false,
      animationFrameIds: {},
    };
  },
  computed: {
    limitedOpcoes() {
      const maxOptions = this.hasEnqueteImage ? 6 : 8; // Image shows 6 options max
      return (this.item?.enquete_opcoes || []).slice(0, maxOptions);
    },
    hasOptionsWithImages() {
      return this.limitedOpcoes.some(
        opcao => opcao.url_imagem && !this.brokenImages[opcao.id]
      );
    },
    hasEnqueteImage() {
      return this.item?.url_imagem_enquete && !this.brokenEnqueteImage;
    },
    // True when some option label has a long word, so the box gets extra width.
    // Short labels (SIM, NAO, Caiu...) stay at the 665px standard. Tune LONG_WORD_LEN.
    hasLongOptionLabel() {
      const LONG_WORD_LEN = 5;
      return this.limitedOpcoes.some((opcao) =>
        String(opcao.dsc_titulo || '')
          .trim()
          .split(/\s+/)
          .some((word) => word.length > LONG_WORD_LEN)
      );
    },
  },
  watch: {
    'item.flg_exibir_resultado': {
      handler(newVal) {
        if (newVal) {
          this.limitedOpcoes.forEach((opcao) => {
            this.animateValue(opcao.id, 0, opcao.resultado || 0);
          });
        } else {
          this.animatedPercentages = {};
        }
      },
      immediate: true,
    },
    'item.enquete_opcoes': {
      handler(newOpcoes, oldOpcoes) {
        if (newOpcoes) {
          const limitedNewOpcoes = newOpcoes.slice(0, 8);
          const limitedOldOpcoes = oldOpcoes?.slice(0, 8);

          limitedNewOpcoes.forEach((opcao) => {
            const oldOpcao = limitedOldOpcoes?.find(o => o.id === opcao.id);
            if (oldOpcao && oldOpcao.url_imagem !== opcao.url_imagem) {
              this.$set(this.brokenImages, opcao.id, false);
            }
          });

          if (this.item.flg_exibir_resultado) {
            limitedNewOpcoes.forEach((opcao) => {
              const currentValue = this.animatedPercentages[opcao.id] || 0;
              if (currentValue !== opcao.resultado) {
                this.animateValue(opcao.id, currentValue, opcao.resultado || 0);
              }
            });
          }
        }
      },
      deep: true,
    },
    'item.url_imagem_enquete': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.brokenEnqueteImage = false;
        }
      },
    },
  },
  beforeDestroy() {
    Object.values(this.animationFrameIds).forEach(id => cancelAnimationFrame(id));
  },
  methods: {
    animateValue(key, fromValue, toValue) {
      if (this.animationFrameIds[key]) {
        cancelAnimationFrame(this.animationFrameIds[key]);
      }
      const startTime = Date.now();
      const difference = toValue - fromValue;

      const animate = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / this.animationDuration, 1);
        const easeOutCubic = 1 - Math.pow(1 - progress, 3);

        this.$set(
          this.animatedPercentages,
          key,
          Math.round(fromValue + difference * easeOutCubic)
        );

        if (progress < 1) {
          this.animationFrameIds[key] = requestAnimationFrame(animate);
        } else {
          delete this.animationFrameIds[key];
        }
      };

      this.animationFrameIds[key] = requestAnimationFrame(animate);
    },
    formatOptionLabel(text) {
      if (!text) return text;
      // Break a multi-word option label onto two lines: before the first Portuguese
      // connector (de/do/da/na/no...) if there is one, otherwise before the last word.
      // Single words stay on one line; a connector stays glued to the word after it.
      const connectors = new Set([
        'da', 'das', 'de', 'di', 'do', 'dos', 'du',
        'na', 'nas', 'ne', 'ni', 'no', 'nos', 'nu',
      ]);
      const words = String(text).trim().split(/\s+/);
      if (words.length <= 1) return words[0] || '';
      let breakIndex = words.findIndex((w, i) => i > 0 && connectors.has(w.toLowerCase()));
      if (breakIndex === -1) breakIndex = words.length - 1;
      const glued = words.reduce((acc, word, i) => {
        if (i === 0) return word;
        let sep = ' ';
        if (i === breakIndex) {
          sep = '\n';
        } else if (connectors.has(words[i - 1].toLowerCase())) {
          sep = ' ';
        }
        return acc + sep + word;
      }, '');
      // Keep hyphenated words (e.g. "mata-mata") from breaking at the hyphen
      return glued.replace(/(\S)-(\S)/g, '$1‑$2');
    },
    handleImageError(opcaoId) {
      this.$set(this.brokenImages, opcaoId, true);
    },
    handleEnqueteImageError() {
      this.brokenEnqueteImage = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "GaleanaExtended";
  src: url("@/assets/CopaTVFechada/Galeana Extended Regular.otf") format("opentype");
}

@font-face {
  font-family: "Ferryman";
  font-weight: 900;
  font-style: italic;
  src: url("@/assets/CopaTVFechada/Ferryman/Ferryman Black Italic.otf") format("opentype");
}

.copa-tv-fechada-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: fit-content;
  margin-bottom: 10px;

  /* Standalone (enquete-only) safe area: lift off the bottom edge.
     54px matches the combined wrapper (44px padding + 10px inner margin).
     In combined mode the wrapper provides the safe area instead. */
  &.standalone {
    margin-bottom: 54px;
  }

  &.position-esquerda {
    justify-self: flex-start;
    margin-left: 35px;
  }

  &.position-centro {
    justify-self: center;
    margin-left: auto;
    margin-right: auto;
  }

  &.position-direita {
    justify-self: flex-end;
    margin-right: 35px;
  }
}

.poll-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.title-container {
  position: relative;
  width: fit-content;
  min-width: 573px;
  max-width: 100%;
  height: 54.28px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 1;
  margin-bottom: -3px;
  margin-left: -20px;
  padding: 0;
  padding-left: 80px;
  padding-right: 60px;
}

.title-bg-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  display: flex;
}

.bg-left {
  width: 100px;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
}

.bg-middle {
  flex-grow: 1;
  height: 100%;
  background: linear-gradient(90deg, #03134c, #0653c2);
}

.bg-right {
  width: 60px;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
}

.title-bg-svg {
  width: 100%;
  height: 100%;
  display: block;
}

.title-text {
  font-family: 'Ferryman', serif;
  color: #eebb55;
  font-size: 1.6rem;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: visible;
  width: auto;
  text-align: start;
}

.options-container {
  background: linear-gradient(to right, #dca850, #f1ce89);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 26px 0px 40px;
  height: 135px;
  min-width: 665px;
  box-sizing: border-box;
  z-index: 1;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;

  &.options-wide {
    min-width: 797px;
  }

  /* QR-overlap spacing: only when combined with the QR code. Standalone
     (enquete-only) keeps the normal left inset above. */
  &.with-qrcode {
    padding-left: 95px;
    margin-left: -25px;
  }
}

.enquete-image-section {
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 135px;
  margin-left: 20px;
  margin-right: 26px;

  .enquete-image {
    display: block;
    height: 98%;
    width: auto;
    max-width: 100%;
    object-fit: contain;
  }
}

.options-grid {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex: 1;
  justify-content: space-around;
  gap: 13px;
  height: 100%;

  /* When there is no enquete image, the grid is the first child, so give it the
     same left clearance the flag has (so the first option doesn't crowd the QR). */
  &:first-child {
    margin-left: 20px;
  }
}

.option-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 13px;
  height: 100%;
}

.option-image {
  flex-shrink: 0;
  height: 100%;
  display: flex;
  align-items: center;

  img {
    height: 90%;
    width: auto;
    object-fit: contain;
  }
}

.option-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  min-width: 110px;
  min-height: 90px;
}

.option-label {
  font-family: 'Ferryman', serif;
  font-size: 1.6rem;
  color: #020202;
  white-space: pre-line;
  text-align: left;
  line-height: 1.1;
  max-width: 170px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.percentage-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 3px;
}

.percentage-value {
  font-family: 'GaleanaExtended', sans-serif;
  font-size: 1.6rem;
  font-weight: bold;
  color: #222;
}
</style>
